<template>
    <div class="checkbox-invalid">
        <b-form-group
            class="kyc-status-radio overwrite-radio"
            :label="field.label"
            :label-for="`id_${field._id}`"
            :class="{
                'required-field': requiredFields,
            }"
        >
            <b-form-checkbox-group
                :id="`id_${field._id}`"
                v-model="selected"
                v-validate="{
                    required: requiredFields,
                }"
                :options="field.options"
                :name="field._id"
                :disabled="loading"
                :data-vv-name="field.label"
                @input="set"
                :class="{
                    'is-invalid': errors.has(field.label),
                }"
            ></b-form-checkbox-group>
        </b-form-group>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import TextField from './TextField'
export default {
    // End of Component > inject
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {},
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    //    extends: TextField, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {
        $validator: '$validator',
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            required: true,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            textField: 'title',
            valueField: '_id',
            options: [],
            value: [],
            newSelectedValue: [],
            selected: [],
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */

    computed: {
        ...mapGetters(['loading']),
        requiredFields()
        {
            let fieldNames=['sourceOfWealth.evidenced',
                'sourceOfWealth.evidenceDocument.fileName',
                'sourceOfFunds.evidenced',
                'sourceOfFunds.evidenceDocument.fileName']
            if(fieldNames.indexOf(this.field.key) > -1)
            {
                return false
            }

            return this.field.isRequired
        },
        selected: {
            /**
             * Getter to get value for computed property
             * using props from parent componennt
             *
             * @return {mix}
             */
            get: function () {
                if (this.field.isLocked) {
                    console.log('My Values : ', this.value)
                    console.log(
                        'this.$store.getters.getField(this.field.key) :',
                        this.$store.getters.getField(this.field.key)
                    )
                    return this.$store.getters.getField(this.field.key)
                } else {
                    let customInfo = this.$store.getters.getField(`customInfo`)
                    return customInfo[this.field._id]
                        ? customInfo[this.field._id].value
                        : null
                }
            }, // End of get() method
        },
    }, // End of Component > methods
    // End of Component > methods


    created(){
        var some = this.field.key.split('.')
        // console.log('model kesa',this.field.customerDetails.this.field.key)
        if (this.field.customerDetails[some[0]][some[1]]){
            this.selected = this.field.customerDetails[some[0]][some[1]]
            this.set( this.field.customerDetails[some[0]][some[1]])

        }
       
   },
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        if (this.$store.getters.getField(this.field.key)) {
            this.selected = this.getterFunction()
        }
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        // Getting checkbox values
        getterFunction() {
            console.log('Getter fundtion in Methods')
            if (this.field.isLocked) {
                console.log('Getter fundtion in Methods After IsLOCKED')
                console.log('My Values : ', this.value)
                console.log(
                    'this.$store.getters.getField(this.field.key) :',
                    this.$store.getters.getField(this.field.key)
                )
                return this.$store.getters.getField(this.field.key)
            } else {
                let customInfo = this.$store.getters.getField(`customInfo`)
                return customInfo[this.field._id]
                    ? customInfo[this.field._id].value
                    : null
            }
        }, // End of get() method
        /**
         * Setter to set value for computed property
         * notifying the parent component
         *
         * @return {void}
         */
        set: function (newValue) {
            this.value = newValue
            if (this.field.isLocked) {
                this.$store.commit('updateField', {
                    key: this.field.key,
                    value: newValue,
                })
            } else {
                this.$store.commit('updateField', {
                    key: `customInfo.${this.field._id}`,
                    value: {
                        title: this.field.label,
                        type: this.field.type,
                        value: newValue,
                    },
                })
            }
        }, // End of set() method
    }, // End of Component > mounted
}
</script>
